import React from 'react';
import PropTypes from 'prop-types';
import Lottie from 'react-lottie';

const propTypes = {
    animationData: PropTypes.object.isRequired,
    renderSettings: PropTypes.object,
    loop: PropTypes.bool,
    autoplay: PropTypes.bool,
    width: PropTypes.number,
    height: PropTypes.number,
    speed: PropTypes.number,
    eventListeners: PropTypes.array,
    isstopped: PropTypes.bool,
    ispaused: PropTypes.bool,
};
const defaultProps = {
    renderSettings: {
        preserveAspectRatio: 'xMidYMid slice',
    },
    loop: false,
    autoplay: false,
    width: null,
    height: null,
    eventListeners: [],
    isstopped: false,
    ispaused: false,
};

const LottieAnimation = ({ animationData, renderSettings, loop, autoplay, width, height, speed, eventListeners, isstopped, ispaused, ...props }) => {
    const lottieOptions = {
        animationData,
        renderSettings,
        loop,
        autoplay,
        speed,
    };

    return (
        <div {...props}>
            <Lottie
                options={lottieOptions}
                width={width}
                height={height}
                speed={speed}
                eventListeners={eventListeners}
                isStopped={isstopped}
                isPaused={ispaused}
                {...props}
            />
        </div>
    );
};

LottieAnimation.propTypes = propTypes;
LottieAnimation.defaultProps = defaultProps;

export default LottieAnimation;
